import fileAsset from './fileAsset'
import imageAsset from './imageAsset'
import metadata from './metadata'
import productData from './productData'
import link from './link'

export const basicPageFields = `
  _type,
  _createdAt,
  _updatedAt,
  title,
  slug
`

export const pageMetadataFields = `
  ${basicPageFields},
  ${metadata.fragment()},
  _type == "product" => {
    ${productData.fragment('productData')},
  }
`

export const basicProductFields = `
  ${basicPageFields},
  ...productData {
    ${productData.basicFields}
  }
  
`

export const richTextFields = `
  _key,
  _type,
  children[] {
    ...,
    _type == "link" => {
      ${link.fields}
    },
  },
  style,
  listItem,
  level,
  markDefs[]{
    ...,
    _type == "link" => {
      ${link.fields}
    },
  },
`

export const textAndImagesFields = `
  type,
  ${imageAsset.fragment('image')},
  ${fileAsset.fragment('videoLoopDesktop')},
  ${fileAsset.fragment('videoLoopMobile')}
`
